<script setup>
  import { ref, watch, onMounted, computed } from 'vue';
  import axios from 'axios';
  import FormSelect from '~/components/form/FormSelect.vue';

  const props = defineProps({
    modelValue: {
      type: String,
      required: false,
      default: '',
    },
    country: {
      type: String,
      required: false,
      default: '',
    },
  });
  const emit = defineEmits(['update:modelValue']);
  const stateList = ref([]);
  const internalValue = computed({
    get() {
      return props.modelValue;
    },
    set(newValue) {
      emit('update:modelValue', newValue);
    },
  });

  watch(
    () => props.country,
    async function (newValue, oldValue) {
      if (newValue && oldValue && newValue !== oldValue) {
        internalValue.value = '';
      }
      if (newValue) {
        await getStatesList();

        if (stateList.value.length === 1) {
          internalValue.value = Object.values(stateList.value)[0].value;
        }
      }
    }
  );

  async function getStatesList() {
    try {
      const { data } = await axios.get(`/countries/${props.country}`);

      const statesOptions = data.map((state) => ({
        value: state.state_code,
        label: state.name,
      }));
      stateList.value = statesOptions;
    } catch (err) {
      stateList.value = [];
    }
  }

  onMounted(() => {
    getStatesList();
  });
</script>

<template>
  <FormSelect
    v-model="internalValue"
    :options="stateList"
    placeholder-text="Select a State"
  />
</template>
